import { footerColumns, siteMeta } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200 pt-12 md:pt-16">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className="ri-link" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">{siteMeta.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 max-w-md">
              {siteMeta.tagline}。本页汇总黑料地址最新入口、防走丢永久链接与实时状态，收藏一次即可长期使用。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-xs font-label text-secondary-800">
              <i className="ri-time-line" aria-hidden="true" />
              {siteMeta.updatedLabel} {siteMeta.updatedAt}
            </p>
          </div>

          {footerColumns.map((column) => (
            <nav key={column.id} className="lg:col-span-2" aria-label={column.title}>
              <h3 className="font-heading text-sm font-bold text-foreground-950">{column.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-[13px] font-label text-foreground-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 rounded-lg bg-background-50 border border-secondary-200 p-5">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-secondary-700 text-lg mt-0.5" aria-hidden="true" />
            <p className="text-[13px] leading-relaxed text-foreground-600">
              本站仅提供地址发布与访问状态展示，不参与任何内容的制作与存储。页面上的入口信息会随维护节奏更新，请以本页展示的当前状态为准。
            </p>
          </div>
        </div>

        <div className="mt-8 py-6 border-t border-secondary-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-label text-secondary-800">
            © {new Date().getFullYear()} {siteMeta.name} · 保留所有权利
          </p>
          <p className="text-xs font-label text-secondary-800">
            黑料地址最新入口 · 防走丢 · 永久链接 · 防屏蔽
          </p>
        </div>
      </div>
    </footer>
  );
}